import React, { Fragment } from "react";
import Flatpickr from "react-flatpickr";

import moment from "moment";

import { Portuguese } from "flatpickr/dist/l10n/pt";

// * Flatpicker
import "@styles/react/libs/flatpickr/flatpickr.scss";
import "flatpickr/dist/plugins/monthSelect/style.css";

const dateCurrent = new Date();

export const DatePickerDaily = ({
  date,
  value,
  height = "auto",
  width,
  style,
  onChange = () => {},
}) => {
  const current = moment(dateCurrent).format("DD/MM");
  const equal =
    new Date(date?.[0] || value?.[0]).toLocaleDateString() ===
    new Date(date?.[1] || value?.[1]).toLocaleDateString();

  return (
    <Fragment>
      <input type="hidden" className="date" name="mother" />
      <Flatpickr
        options={{
          disableMobile: true,
          locale: Portuguese,
          formatDate: dateValue => {
            const dateSelected = moment(dateValue).format("DD/MM");

            return current === dateSelected
              ? "Hoje"
              : moment(dateValue).format("DD/MM");
          },
          mode: "range",
        }}
        style={{
          width:
            date?.length > 1
              ? equal
                ? "5rem"
                : "9rem"
              : width
              ? "100%"
              : "5rem",
          height,
          background: "transparent",
          justifyItems: "center",
          ...style,
        }}
        className="form-control text-primary border-primary"
        value={value || date}
        onChange={onChange}
        id="default-picker"
      />
    </Fragment>
  );
};
